<template>
  <div><i>Senast uppdaterad {{date | formattedTimeDate}}</i></div>
</template>

<script>
export default {
  props: ['date']
}
</script>